// Common imports
const configureCommonStore = require('client-v2/common/state/store')

function configureStore(options) {
  return configureCommonStore(
    Object.assign({
      reducer: require('./reducer'),
      reviver: require('./record').reviver
    }, options)
  )
}

module.exports = configureStore
